<template>
  <!-- screen used for when the token is expired, right after is directed to login -->
  <div class="container-fluid py-5 background-login">
    <div class="row" style="width: 100%; height: 450px">
      <div class="col-sm-9 col-md-7 col-lg-4 mx-auto div-url">
        <h5 style="font-size: 65px; padding: 40px">OPS...</h5>

        <h5 class="card-title text-center text-join">
          A sua sessão expirou, faça seu login novamente!
        </h5>
        <div class="access-center">
          <button
            class="btn btn-lg access-expired"
            id="loginUrlExpired"
            type="submit"
            @click="clickLogin"
          >
            Fazer login
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "UrlExpired",
  data() {
    return {};
  },
  methods: {
    clickLogin: function () {
      this.$router.push({ path: `${this.$route.query.group}` });
    },
  },
  mounted() {
    let group = this.$route.query.group;

    axios.get(`${process.env.API_PBM}/group/${group}`).then((response) => {
      let background = response.data.data.background;
      let logo = response.data.data.logo;
      if (background != null) {
        document.body.className = "background-login";
        document.body.style.backgroundImage = `url("${background}")`;
      }
      this.logoImage = logo != null ? logo : "";
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-url {
  background: rgba(255, 255, 255, 0.8);
  border: none;
  margin-top: 5%;
}
.background-login {
  height: 100%; /* Center and scale the image nicely */
  background-repeat: no-repeat center;
  background-size: cover;
}
.logo-image {
  width: 100%;
  max-width: 240px;
}

.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-top: 5px;
  font-size: 18px;
  margin-bottom: 40px;
}

.access-expired {
  background-color: #b0191a;
  color: #fff;
  width: 30%;
  margin-top: 70px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  text-decoration: none !important;
}

.access-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/common/components/UrlExpired.vue